





























































import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { DropdownFilter, IDropdownFilter } from '@/models/filters/Filters';

const Component = defineComponent({
  name: 'Product',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.PRODUCT;
    const filtersDropdown: IDropdownFilter[] = [
      new DropdownFilter({
        label: 'Category',
        filterType: 'category',
        itemsModuleName: 'categoriesModule',
        hasDefaultValue: true,
      }),
    ];

    const state = reactive({
      headers: [
        { text: 'Image', value: 'thumbImage', sortable: false, editable: true },
        { text: 'Name', value: 'name', sortable: true, searchable: true, editable: true },
        {
          text: 'Categories',
          value: 'categories',
          align: 'center',
          sortable: true,
          editable: true,
        },
        { text: 'Position', value: 'position', align: 'center', sortable: true },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
      filtersDropdown,
    };
  },
});
export default Component;
